import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getLocalidadClientesActivos`, method: 'GET', body: null, token: token})
}
